function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHtml = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.902 27.201 3.655 2h24.69l-2.25 25.197L15.985 30z",
  style: {
    fill: "#e44f26"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 27.858 8.17-2.265 1.922-21.532H16z",
  style: {
    fill: "#f1662a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 13.407h-4.09l-.282-3.165H16V7.151H8.25l.074.83.759 8.517H16zM16 21.434l-.014.004-3.442-.929-.22-2.465H9.221l.433 4.852 6.332 1.758.014-.004z",
  style: {
    fill: "#ebebeb"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.989 13.407v3.091h3.806l-.358 4.009-3.448.93v3.216l6.337-1.757.046-.522.726-8.137.076-.83h-7.1850000000000005M15.989 7.151v3.0909999999999997h7.466l.062-.694.141-1.567.074-.83z",
  style: {
    fill: "#fff"
  }
}));
export default SvgHtml;